<template>
  <div>
    <el-form ref="cleanForm" :rules="rules" :model="addFormExtend" label-width="120px">
      <el-form-item label="保洁描述" prop="description">
        <el-input
          type="textarea"
          placeholder="请输入 保洁描述"
          v-model="addFormExtend.description" maxlength="100"
          rows="4"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="保洁备注" prop="remark">
        <el-input
          type="textarea"
          placeholder="请输入 保洁备注"
          v-model="addFormExtend.remark" maxlength="100"
          rows="4"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { vString } from "@/util/validate";
export default {
  props: ["addFormExtend"],
  data() {
    return {
      rules: {
        description: [
          { required: true, message: "请输入保洁描述", trigger: "change" },
          { validator: vString("保洁备注"), trigger: "change" },
        ],
        remark: [
          { required: true, message: "请输入保洁备注", trigger: "change" },
          { validator: vString("保洁备注"), trigger: "change" },
        ],
      },
    };
  },
  methods: {
    validate() {
      return new Promise((res, rej) => {
        this.$refs.cleanForm.validate((valid) => {
          res(valid)
        });
      });
    },
  },
};
</script>

<style>
</style>